export default __webpack_public_path__ + "static/media/tile-des1-fr.e7d37626.gif";